import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { VialImage } from "@/components/VialImage";
import { Plus } from "@phosphor-icons/react";
import { toast } from "sonner";

export const AddonPicks = ({ gap }) => {
  const { items, add } = useCart();
  const [picks, setPicks] = useState([]);
  const exclude = items.map((i) => i.product_id).join(",");
  const roundedGap = Math.ceil(gap);
  useEffect(() => {
    api.get("/products/addon-picks", { params: { gap: roundedGap, exclude } })
      .then((r) => setPicks(r.data)).catch(() => setPicks([]));
  }, [exclude, roundedGap]);
  if (!picks.length) return null;
  return (
    <div data-testid="addon-picks" className="mt-4">
      <p className="label-mono text-muted-foreground text-[0.55rem] mb-2">Popular add-ons</p>
      <div className="grid grid-cols-3 gap-2">
        {picks.map((p) => (
          <div key={p.id} data-testid={`addon-pick-${p.id}`} className="border border-white/10 bg-white/[0.03] p-2 flex flex-col">
            <div className="h-20 bg-white mb-2 overflow-hidden"><VialImage name={p.name} showName={false} /></div>
            <p className="text-[0.7rem] leading-tight line-clamp-2 min-h-[2.1em]">{p.name}</p>
            <p className="font-mono text-[0.7rem] text-primary mt-1">${p.price?.toFixed(2)}</p>
            <button data-testid={`addon-add-${p.id}`} onClick={() => { add(p, 1); toast.success(`${p.name} added`); }}
              className="mt-2 label-mono text-[0.55rem] py-1.5 border border-primary/50 text-primary hover:bg-primary hover:text-black inline-flex items-center justify-center gap-1"
              style={{ transition: "background-color 0.2s, color 0.2s" }}><Plus size={10} weight="bold" /> Add</button>
          </div>
        ))}
      </div>
    </div>
  );
};
